import GenericRequest, { METHOD_GET } from '../../../../../shared/webservices/GenericRequest';

export class MachineDetailTask extends GenericRequest {

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/update/machine-detail/MachineDetailTask.js